module.exports = __webpack_public_path__ + "static/media/instagramIcon.40aa8003.svg";